/*
import React from "react";

const Conference = ({ id_conference }) => {
  return (
    <div className="training-school-page">
      <h1>Conference</h1>
      <p>
        Stai visualizzando la pagina per: <strong>{id_conference}</strong>
      </p>
      <p>
        Stai visualizzando la pagina per: <strong>{id_conference.split("/")[0]}</strong>
      </p>
      <p>
        Stai visualizzando la pagina per: <strong>{id_conference.split("/")[1]}</strong>
      </p>
    </div>
  );
};

export default Conference;
*/

import React, { useEffect, useState } from "react";
import axios from "axios";
//import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import serverConfig from "../config";
import "./Home.css";
import "react-datepicker/dist/react-datepicker.css";
//import { momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
//import moment from "moment";
import { useNavigate } from "react-router-dom";

import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import UpdatePaths from "../utils/UpdatePaths";

import toast, { Toaster } from "react-hot-toast";
import ConferenceRegistrationForm from "./ConferenceFormRegistration";
import ConferenceFormRegistration from "./ConferenceFormRegistration";
import ConferenceFormAbstract from "./ConferenceFormAbstract";
import ConferenceFormFellowship from "./ConferenceFormFellowship";
//moment.locale("it"); // Imposta la localizzazione su italiano
//const localizer = momentLocalizer(moment);

const Conference = ({ id_conference }) => {
  //const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);
  //const { year_conference, name_conference } = useParams();

  const [year_conference, setYearConference] = useState(null);
  const [name_conference, setNameConference] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    //const year = localStorage.getItem("year_conference");
    //const name = localStorage.getItem("name_conference");
    const parts = id_conference.split("-");
    const year = parts[0];
    const name = parts[1];
    //setYearConference(year);
    //setNameConference(name);
    if (!name || !year) {
      navigate("/conferences_workshop"); // Reindirizza se i valori non esistono
    } else {
      setYearConference(year);
      setNameConference(name);
    }
  }, [year_conference, name_conference]);

  const [contentConferenceHeader, setContentConferenceHeader] = useState(null);
  const [contentConferenceInfo, setContentConferenceInfo] = useState(null);
  const [contentConferenceSponsor, setContentConferenceSponsor] = useState([]);
  //const [contentConferenceSponsorTxt, setContentConferenceSponsorTxt] =useState([]);
  /*const [contentConferenceSponsoredBy, setContentConferenceSponsoredBy] =
    useState([]);
  const [
    contentConferenceSupportingInstitutions,
    setContentConferenceSupportingInstitutions,
  ] = useState([]);*/
  const [contentConferenceCommitteess, setContentConferenceCommitteess] =
    useState(null);
  const [contentConferenceProgram, setContentConferenceProgram] =
    useState(null);
  const [contentConferenceProgramTxt, setContentConferenceProgramTxt] =
    useState(null);
  const [
    contentConferenceInfoRegistration,
    setContentConferenceInfoRegistration,
  ] = useState(null);
  const [contentConferenceSubmitAbstr, setContentConferenceSubmitAbstr] =
    useState(null);
  const [fileBookOfAbstract, setFileBookOfAbstract] = useState(null);

  const [dateRegistration, setDateRegistration] = useState(null);
  const [dateAbstract, setDateAbstract] = useState(null);
  const [dateFellowship, setDateFellowship] = useState(null);
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];

  useEffect(() => {
    if (name_conference && year_conference) {
      axios
        .post(`${serverConfig.serverUrl}/get_info_conference`, {
          name_conference: name_conference,
          year_conference: year_conference,
        })
        .then((response) => {
          const data = response.data["data_conference"];
          const exist = response.data["exist"];
          if (exist) {
            const updatedContent = {
              header: UpdatePaths(
                data.header,
                `img/conference/${year_conference}/${name_conference}/IMG/HOME/`,
                `file/conference/${year_conference}/${name_conference}/FILE/HOME/`
              ),
              info: UpdatePaths(
                data.info,
                `img/conference/${year_conference}/${name_conference}/IMG/HOME/`,
                `file/conference/${year_conference}/${name_conference}/FILE/HOME/`
              ),
              programTxt: UpdatePaths(
                data.programEventTxt,
                `img/conference/${year_conference}/${name_conference}/IMG/PROGRAM/`,
                `file/conference/${year_conference}/${name_conference}/FILE/PROGRAM/`
              ),
              sponsorTxt: UpdatePaths(
                data.sponsorTxt,
                `img/conference/${year_conference}/${name_conference}/IMG/SPONSOR/`,
                `file/conference/${year_conference}/${name_conference}/FILE/SPONSOR/`
              ),
              submitAbstr: UpdatePaths(
                data.submit_abstr,
                `img/conference/${year_conference}/${name_conference}/IMG/SUBMISSIONABS/`,
                `file/conference/${year_conference}/${name_conference}/FILE/SUBMISSIONABS/`
              ),
              infoRegistration: UpdatePaths(
                data.info_registration,
                `img/conference/${year_conference}/${name_conference}/IMG/INFO/`,
                `file/conference/${year_conference}/${name_conference}/FILE/INFO/`
              ),

            };
            setContentConferenceHeader(updatedContent["header"]);
            setContentConferenceInfo(updatedContent["info"]);
            setContentConferenceProgramTxt(updatedContent["programTxt"]);
            setContentConferenceSubmitAbstr(updatedContent["submitAbstr"]);
            setContentConferenceInfoRegistration(
              updatedContent["infoRegistration"]
            );
            setContentConferenceSponsor(data.sponsor);
            setContentConferenceProgram(data.programEvent);
            setContentConferenceCommitteess(data.committeeMembers);
            setDateRegistration(data.dateRegistration);
            setDateAbstract(data.dateAbstract);
            setDateFellowship(data.dateFellowship);
            setFileBookOfAbstract(data.bookAbstract);
          } else {
            toast.error("Non esiste la conferenza indicata");
            navigate("/conferences_workshop");
          }
        })
        .catch((error) => {
          toast.error("La risorsa non è al momento disponibile");
        });

      localStorage.removeItem("year_conference");
      localStorage.removeItem("name_conference");
    }
  }, [name_conference, year_conference]);

  /*
  const renderCarousel = (carouselItems) => {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      vertical: true,
      autoplaySpeed: 3000,
      verticalSwiping: true,
      prevArrow: <CustomPrevArrow />,
      nextArrow: <CustomNextArrow />,
    };

    return (
      <div className="carousel-container">
        {carouselItems && (
          <Slider {...settings}>
            {carouselItems.map((item, index) => (
              <div key={index} className="carousel-item">
                <div className="image-wrapper">
                  <img
                    src={`${serverConfig.serverUrl}/img/conference/${year_conference}/${name_conference}/IMG/SPONSOR/${item.name}`}
                    alt="sponsor"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxWidth: "70%",
                      maxHeight: "150px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            ))}
          </Slider>
        )}
      </div>
    );
  };
  

  const CustomPrevArrow = (props) => {
    return <></>;
  };

  const CustomNextArrow = (props) => {
    return <></>;
  };
  */

  const [activeTab, setActiveTab] = useState("home");
  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const navContents = (
    <>
      <Nav>
        <NavItem>
          <NavLink
            style={
              activeTab === "home"
                ? {
                    color: "#F5F7FA",
                    backgroundColor: "#003366",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "15px",
                  }
                : {
                    color: "#2C2C2C",
                    backgroundColor: "#D8DEE9",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "12px",
                  }
            }
            onClick={() => {
              toggle("home");
            }}
          >
            HOME
          </NavLink>
        </NavItem>
        {contentConferenceCommitteess &&
          Object.keys(contentConferenceCommitteess).length !== 0 && (
            <NavItem>
              <NavLink
                style={
                  activeTab === "committees"
                    ? {
                        color: "#F5F7FA",
                        backgroundColor: "#003366",
                        borderRadius: "10px",
                        margin: "10px",
                        fontSize: "15px",
                      }
                    : {
                        color: "#2C2C2C",
                        backgroundColor: "#D8DEE9",
                        borderRadius: "10px",
                        margin: "10px",
                        fontSize: "12px",
                      }
                }
                onClick={() => {
                  toggle("committees");
                }}
              >
                COMMITTEESS
              </NavLink>
            </NavItem>
          )}
        {contentConferenceSponsor &&
          Object.keys(contentConferenceSponsor).length !== 0 && (
            <NavItem>
              <NavLink
                style={
                  activeTab === "sponsor"
                    ? {
                        color: "#F5F7FA",
                        backgroundColor: "#003366",
                        borderRadius: "10px",
                        margin: "10px",
                        fontSize: "15px",
                      }
                    : {
                        color: "#2C2C2C",
                        backgroundColor: "#D8DEE9",
                        borderRadius: "10px",
                        margin: "10px",
                        fontSize: "12px",
                      }
                }
                onClick={() => {
                  toggle("sponsor");
                }}
              >
                SPONSOR
              </NavLink>
            </NavItem>
          )}

        {contentConferenceProgram &&
          Object.keys(contentConferenceProgram).length !== 0 &&
          contentConferenceProgram.txt !== "" && (
            <NavItem>
              <NavLink
                style={
                  activeTab === "program"
                    ? {
                        color: "#F5F7FA",
                        backgroundColor: "#003366",
                        borderRadius: "10px",
                        margin: "10px",
                        fontSize: "15px",
                      }
                    : {
                        color: "#2C2C2C",
                        backgroundColor: "#D8DEE9",
                        borderRadius: "10px",
                        margin: "10px",
                        fontSize: "12px",
                      }
                }
                onClick={() => {
                  toggle("program");
                }}
              >
                PROGRAM
              </NavLink>
            </NavItem>
          )}
        {contentConferenceInfoRegistration &&
          contentConferenceInfoRegistration !== "" && (
            <>
              <NavItem>
                <NavLink
                  style={
                    activeTab === "info"
                      ? {
                          color: "#F5F7FA",
                          backgroundColor: "#003366",
                          borderRadius: "10px",
                          margin: "10px",
                          fontSize: "15px",
                        }
                      : {
                          color: "#2C2C2C",
                          backgroundColor: "#D8DEE9",
                          borderRadius: "10px",
                          margin: "10px",
                          fontSize: "12px",
                        }
                  }
                  onClick={() => {
                    toggle("info");
                  }}
                >
                  INFO
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  style={
                    activeTab === "registration"
                      ? {
                          color: "#F5F7FA",
                          backgroundColor: "#003366",
                          borderRadius: "10px",
                          margin: "10px",
                          fontSize: "15px",
                        }
                      : {
                          color: "#2C2C2C",
                          backgroundColor: "#D8DEE9",
                          borderRadius: "10px",
                          margin: "10px",
                          fontSize: "12px",
                        }
                  }
                  onClick={() => {
                    toggle("registration");
                  }}
                >
                  REGISTRATION
                </NavLink>
              </NavItem>
            </>
          )}
        {contentConferenceSubmitAbstr &&
          contentConferenceSubmitAbstr !== "" && (
            <NavItem>
              <NavLink
                style={
                  activeTab === "submit"
                    ? {
                        color: "#F5F7FA",
                        backgroundColor: "#003366",
                        borderRadius: "10px",
                        margin: "10px",
                        fontSize: "15px",
                      }
                    : {
                        color: "#2C2C2C",
                        backgroundColor: "#D8DEE9",
                        borderRadius: "10px",
                        margin: "10px",
                        fontSize: "12px",
                      }
                }
                onClick={() => {
                  toggle("submit");
                }}
              >
                SUBMIT ABSTR
              </NavLink>
            </NavItem>
          )}
        <NavItem>
          <NavLink
            style={
              activeTab === "fellowship"
                ? {
                    color: "#F5F7FA",
                    backgroundColor: "#003366",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "15px",
                  }
                : {
                    color: "#2C2C2C",
                    backgroundColor: "#D8DEE9",
                    borderRadius: "10px",
                    margin: "10px",
                    fontSize: "12px",
                  }
            }
            onClick={() => {
              toggle("fellowship");
            }}
          >
            FELLOWSHIP
          </NavLink>
        </NavItem>
        {fileBookOfAbstract && (
          <NavItem>
            <NavLink
              style={
                activeTab === "boa"
                  ? {
                      color: "#F5F7FA",
                      backgroundColor: "#003366",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "15px",
                    }
                  : {
                      color: "#2C2C2C",
                      backgroundColor: "#D8DEE9",
                      borderRadius: "10px",
                      margin: "10px",
                      fontSize: "12px",
                    }
              }
              onClick={() => {
                toggle("boa");
              }}
            >
              BOOK OF ABSTRACT
            </NavLink>
          </NavItem>
        )}
      </Nav>
    </>
  );

  /*
  const contentSponsoredBy = (
    <>
      <div
        style={{
          color: "#003366",
          margin: "20px",
        }}
      >
        <strong>SPONSORED BY</strong>
      </div>
      {renderCarousel(contentConferenceSponsoredBy)}
    </>
  );

  const contentSupportingInstitutions = (
    <>
      <div
        style={{
          color: "darkblue",
          margin: "20px",
        }}
      >
        <strong>SUPPORTING INSTITUTIONS</strong>
      </div>
      {renderCarousel(contentConferenceSupportingInstitutions)}
    </>
  );
  */

  const contentHeader = (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "70%" }}>
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
              backgroundColor: "#FAFAFA",
              color: "#2C2C2C",
            }}
            dangerouslySetInnerHTML={{ __html: contentConferenceHeader }}
          />
        </div>
      </div>
    </>
  );

  /*
  const contentHome = (
    <>
      <div className="row">
        {contentConferenceSponsoredBy.length > 0 && (
          <div className="col-2" style={{ textAlign: "center" }}>
            {contentSponsoredBy}
          </div>
        )}
        <div className="col-8">
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              color: "#2C2C2C",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
            }}
            dangerouslySetInnerHTML={{ __html: contentConferenceInfo }}
          />
        </div>

        {contentSupportingInstitutions.length > 0 && (
          <div className="col-2" style={{ textAlign: "center" }}>
            {contentSupportingInstitutions}
          </div>
        )}
      </div>
    </>
  );
  */

  const contentHome = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {contentConferenceInfo && (
        <div style={{ width: "70%" }}>
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              color: "#2C2C2C",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
            }}
            dangerouslySetInnerHTML={{ __html: contentConferenceInfo }}
          />
        </div>
      )}
    </div>
  );

  const tableCommitteess = (committees) => (
    <div>
      {Object.entries(committees).map(([committeeName, committeeMembers]) => (
        <div key={committeeName}>
          <h2
            style={{
              textAlign: "center",
              backgroundColor: "#003366",
              color: "white",
              borderRadius: "10px",
            }}
          >
            {committeeName.toUpperCase()}
          </h2>
          <div
            className="row"
            style={{ marginBottom: "30px", paddingLeft: "20px" }}
          >
            {committeeMembers &&
              committeeMembers.map((member, index) => (
                <div
                  className="row"
                  style={{ borderBottom: "1px dashed gray", color: "#2C2C2C" }}
                >
                  <div
                    className="col-4"
                    style={{ borderRight: "1px dashed gray" }}
                  >
                    {member.person}
                  </div>
                  <div className="col-8">{member.who}</div>
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );

  const tableProgram = (programs) => (
    <div>
      {Object.entries(programs).map(([programDay, programEvent]) => (
        <div key={programDay}>
          <h2
            style={{
              textAlign: "center",
              backgroundColor: "#003366",
              color: "white",
              borderRadius: "10px",
            }}
          >
            {programDay.toUpperCase()}
          </h2>
          <div
            className="row"
            style={{ marginBottom: "30px", paddingLeft: "20px" }}
          >
            {programEvent &&
              programEvent.map((member, index) => (
                <div
                  className="row"
                  style={{ borderBottom: "1px dashed gray", color: "#2C2C2C" }}
                  S
                >
                  <div
                    className="col-4"
                    style={{
                      borderRight: "1px dashed gray",
                      textAlign: "center",
                    }}
                  >
                    {member.at_time &&
                      (member.at_time.endsWith("a.m.") ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-brightness-high-fill"
                          viewBox="0 0 16 16"
                          style={{ marginRight: "10px" }}
                        >
                          <path d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708" />
                        </svg>
                      ) : member.at_time.endsWith("p.m.") ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-moon-stars"
                          viewBox="0 0 16 16"
                          style={{ marginRight: "10px" }}
                        >
                          <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278M4.858 1.311A7.27 7.27 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.32 7.32 0 0 0 5.205-2.162q-.506.063-1.029.063c-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286" />
                          <path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.73 1.73 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.73 1.73 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.73 1.73 0 0 0 1.097-1.097zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z" />
                        </svg>
                      ) : null)}
                    {member.at_time}
                  </div>
                  <div className="col-8">{member.what}</div>
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );

  /*
  const contentCommittees = (
    <>
      <div className="row">
        {contentConferenceSponsoredBy.length > 0 && (
          <div className="col-2" style={{ textAlign: "center" }}>
            {contentSponsoredBy}
          </div>
        )}
        <div className="col-8">
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            {contentConferenceCommitteess &&
              tableCommitteess(contentConferenceCommitteess)}
          </div>
        </div>
        
        {contentSupportingInstitutions.length > 0 && (
          <div className="col-2" style={{ textAlign: "center" }}>
            {contentSupportingInstitutions}
          </div>
        )}
      </div>
    </>
  );
  */

  const contentCommittees = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "70%" }}>
        <div
          style={{
            boxShadow: "0 0 10px 2px #003366",
            margin: "20px",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          {contentConferenceCommitteess &&
            tableCommitteess(contentConferenceCommitteess)}
        </div>
      </div>
    </div>
  );

  /*
  const contentProgram = (
    <>
      <div className="row">
        {contentConferenceSponsoredBy.length > 0 && (
          <div className="col-2" style={{ textAlign: "center" }}>
            {contentSponsoredBy}
          </div>
        )}
        <div className="col-8">
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            <div
              style={{
                marginBottom: "20px",
              }}
              dangerouslySetInnerHTML={{ __html: contentConferenceProgramTxt }}
            />
            {contentConferenceProgram && tableProgram(contentConferenceProgram)}
          </div>
        </div>
        {contentSupportingInstitutions.length > 0 && (
          <div className="col-2" style={{ textAlign: "center" }}>
            {contentSupportingInstitutions}
          </div>
        )}
      </div>
    </>
  );
  */

  /*
  const contentProgram = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {contentConferenceProgramTxt && (
        <div style={{ width: "70%" }}>
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            <div
              style={{
                marginBottom: "20px",
              }}
              dangerouslySetInnerHTML={{ __html: contentConferenceProgramTxt }}
            />
          </div>
        </div>
      )}

      {contentConferenceProgram && (
        <div style={{ width: "70%" }}>
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            {tableProgram(contentConferenceProgram)}
          </div>
        </div>
      )}
    </div>
  );
  */
  const contentProgram = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {contentConferenceProgramTxt && (
        <div style={{ width: "70%" }}>
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            <div
              style={{
                marginBottom: "20px",
              }}
              dangerouslySetInnerHTML={{ __html: contentConferenceProgramTxt }}
            />
          </div>
        </div>
      )}

      {contentConferenceProgram && (
        <div style={{ width: "70%" }}>
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            {tableProgram(contentConferenceProgram)}
          </div>
        </div>
      )}
    </div>
  );

  /*
  const renderImages = (imageItems) => {
    const colClass = "col-md-6";
    return (
      <div className="image-list row">
        {imageItems &&
          imageItems.map((item, index) => (
            <div key={index} className={`image-wrapper ${colClass}`}>
              <a href={item.link}>{item.name}</a>
            </div>
          ))}
      </div>
    );
  };
  */

  // actual sponsor
  /*
  const contentSponsor = (
    <>
      <div className="row">
        <div className="col-12">
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            {Object.keys(contentConferenceSponsor).map((key, index) => (
              <div key={index}>
                <div
                  style={{
                    textAlign: "center",
                    backgroundColor: "#003366",
                    color: "white",
                    borderRadius: "10px",
                    fontSize: "30px",
                  }}
                >
                  <strong>{key.toUpperCase()}</strong>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    gap: "20px",
                    padding: "20px",
                  }}
                >
                  {renderImagesSponsor(contentConferenceSponsor[key])}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );*/
  const contentSponsor = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "70%" }}>
        <div
          style={{
            boxShadow: "0 0 10px 2px #003366",
            margin: "20px 0",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          {Object.keys(contentConferenceSponsor).map((key, index) => (
            <div key={index}>
              <div
                style={{
                  textAlign: "center",
                  backgroundColor: "#003366",
                  color: "white",
                  borderRadius: "10px",
                  fontSize: "30px",
                  padding: "10px",
                  marginBottom: "10px",
                }}
              >
                <strong>{key.toUpperCase()}</strong>
              </div>
              <div
                style={{
                  textAlign: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  gap: "20px",
                  padding: "20px",
                }}
              >
                {renderImagesSponsor(contentConferenceSponsor[key])}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  function renderImagesSponsor(images) {
    return images.map((image, index) => (
      <div key={index}>
        <a href={image.link} target="_blank" rel="noopener noreferrer">
          <img
            src={`${serverConfig.serverUrl}/img/conference/${year_conference}/${name_conference}/IMG/SPONSOR/${image.name}`}
            alt="sponsor"
            style={{
              /*maxWidth: "400px",
              maxHeight: "400px",
              */
              width: "200px",
              height: "200px",

              objectFit: "contain",
            }}
          />
        </a>
      </div>
    ));
  }

  /*
  const contentInfoRegistration = (
    <>
      <div className="row">
        {contentConferenceSponsoredBy.length > 0 && (
          <div className="col-2" style={{ textAlign: "center" }}>
            {contentSponsoredBy}
          </div>
        )}
        <div className="col-8">
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
              color: "#2C2C2C",
            }}
            dangerouslySetInnerHTML={{
              __html: contentConferenceInfoRegistration,
            }}
          />
        </div>
        {contentSupportingInstitutions.length > 0 && (
          <div className="col-2" style={{ textAlign: "center" }}>
            {contentSupportingInstitutions}
          </div>
        )}
      </div>
    </>
  );
  */

  const contentInfo = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "70%" }}>
        <div
          style={{
            boxShadow: "0 0 10px 2px #003366",
            margin: "20px",
            padding: "10px",
            borderRadius: "10px",
            color: "#2C2C2C",
          }}
          dangerouslySetInnerHTML={{
            __html: contentConferenceInfoRegistration,
          }}
        />
      </div>
    </div>
  );

  /*
  const contentSubmitAbstr = (
    <>
      <div className="row">
        {contentConferenceSponsoredBy.length > 0 && (
          <div className="col-2" style={{ textAlign: "center" }}>
            {contentSponsoredBy}
          </div>
        )}
        <div className="col-8">
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
              color: "#2C2C2C",
            }}
            dangerouslySetInnerHTML={{ __html: contentConferenceSubmitAbstr }}
          />
        </div>
        {contentSupportingInstitutions.length > 0 && (
          <div className="col-2" style={{ textAlign: "center" }}>
            {contentSupportingInstitutions}
          </div>
        )}
      </div>
    </>
  );
  */

  const contentSubmitAbstr = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "70%" }}>
        <div
          style={{
            boxShadow: "0 0 10px 2px #003366",
            margin: "20px",
            padding: "10px",
            borderRadius: "10px",
            color: "#2C2C2C",
          }}
          dangerouslySetInnerHTML={{ __html: contentConferenceSubmitAbstr }}
        />
        {formattedToday <= dateAbstract ? (
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
              color: "#2C2C2C",
            }}
          >
            <ConferenceFormAbstract
              name_conference={name_conference}
              year_conference={year_conference}
            />
          </div>
        ) : (
          <div
            style={{
              boxShadow: "0 0 5px 2px red",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
              color: "white",
              backgroundColor: "red",
            }}
          >
            <h2>Il termine per l'invio degli abstract è scaduto.</h2>
          </div>
        )}
      </div>
    </div>
  );

  const contentRegistration = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "70%" }}>
        {formattedToday <= dateRegistration ? (
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
              color: "#2C2C2C",
            }}
          >
            <ConferenceFormRegistration
              name_conference={name_conference}
              year_conference={year_conference}
            />
          </div>
        ) : (
          <div
            style={{
              boxShadow: "0 0 5px 2px red",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
              color: "white",
              backgroundColor: "red",
            }}
          >
            <h2>Il termine per iscriversi è scaduto.</h2>
          </div>
        )}
      </div>
    </div>
  );

  const contentSubmitFellowship = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "70%" }}>
        {formattedToday <= dateFellowship ? (
          <div
            style={{
              boxShadow: "0 0 10px 2px #003366",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
              color: "#2C2C2C",
            }}
          >
            <ConferenceFormFellowship
              name_conference={name_conference}
              year_conference={year_conference}
            />
          </div>
        ) : (
          <div
            style={{
              boxShadow: "0 0 5px 2px red",
              margin: "20px",
              padding: "10px",
              borderRadius: "10px",
              color: "white",
              backgroundColor: "red",
            }}
          >
            <h2>Il termine per inviare il fellowship è scaduto.</h2>
          </div>
        )}
      </div>
    </div>
  );

  const handleDownloadClick = (event, fileUrl) => {
    event.preventDefault();
    axios
      .get(`${serverConfig.serverUrl}/${fileUrl}`, {
        responseType: "blob", // Indica ad Axios che la risposta è un blob (file)
      })
      .then((response) => {
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileUrl.split("/").pop();
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        //alert("'Errore durante il download del file");
        toast.error("La risorsa non è al momento scaricabile");
      });
  };

  const contentBookOfAbstract = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "70%" }}>
        <div
          style={{
            boxShadow: "0 0 10px 2px #003366",
            margin: "20px",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          {/*}
          QUI ANDRANNO IL PDF DEL BOOK OF ABSTRACT
          <iframe
            title="pdf-preview"
            src={`${serverConfig.serverUrl}/file/regulation/regolamentoDSM.pdf#toolbar=0`}
            width="100%"
            height="600px"
          />
          */}

          <h2
            style={{
              textAlign: "center",
              backgroundColor: "#003366",
              color: "white",
              borderRadius: "10px",
            }}
          >
            BOOK OF ABSTRACT
          </h2>
          {contentHeader}
          <div style={{ marginTop: "10px", textAlign: "center" }}>
            <button
              className="btn btn-outline-primary"
              onClick={() =>
                window.open(
                  `${serverConfig.serverUrl}/file/boa/${year_conference}/${name_conference}/FILE/${fileBookOfAbstract}`,
                  "_blank"
                )
              }
            >
              APRI IN UNA NUOVA FINESTRA
            </button>
            <a
              //href={`${serverConfig.serverUrl}/file/calls_awards/${item.file}`}
              href={`${serverConfig.serverUrl}/file/boa/${year_conference}/${name_conference}/BookOfAbstract.pdf`}
              download
              className="btn btn-primary ms-2"
              //onClick={(e) => handleDownloadClick(e, item.file)}
              onClick={(e) =>
                handleDownloadClick(e, `/file/boa/${year_conference}/${name_conference}/BookOfAbstract.pdf`)
              }
            >
              SCARICA
            </a>
          </div>
        </div>
      </div>
    </div>
  );

  const totalContent = (
    <div style={{ backgroundColor: "#FAFAFA", height: "100vh" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        {navContents}
      </div>
      <div className="row">
        <TabContent activeTab={activeTab}>
          <TabPane tabId="home">
            {contentConferenceHeader && (
              <div style={{ textAlign: "center" }}>{contentHeader}</div>
            )}
            {contentHome}
          </TabPane>
          <TabPane tabId="committees">{contentCommittees}</TabPane>
          <TabPane tabId="sponsor">{contentSponsor}</TabPane>
          <TabPane tabId="program">{contentProgram}</TabPane>
          <TabPane tabId="info">{contentInfo}</TabPane>
          <TabPane tabId="registration">{contentRegistration}</TabPane>
          <TabPane tabId="submit">{contentSubmitAbstr}</TabPane>
          <TabPane tabId="fellowship">{contentSubmitFellowship}</TabPane>
          <TabPane tabId="boa">{contentBookOfAbstract}</TabPane>
        </TabContent>
      </div>
    </div>
  );

  /*
  return (
    <div className="row home-container">
      <div className="col-2 sidebar-left">
        <SidebarLeft />
      </div>
      <div className="col-8 main-content">{totalContent}</div>
      <div className="col-2 sidebar-right">
        <SidebarRight />
      </div>
    </div>
  );
  */

  /*
  return (
    <div
      className={`row home-container ${
        showSidebar ? "show-sidebar" : "hide-sidebar"
      }`}
    >
      <button
        className="show-sidebar-button"
        onClick={() => setShowSidebar(!showSidebar)}
      >
        {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
      </button>
      {window.innerWidth <= 992 ? (
        showSidebar ? (
          <div className="col-12">
            <SidebarLeft />
          </div>
        ) : (
          <div className={`main-content col-12`}>{totalContent}</div>
        )
      ) : (
        <>
          <div className="col-2 sidebar-left">
            <SidebarLeft />
          </div>
          <div className={`main-content ${showSidebar ? "col-10" : "col-12"}`}>
            {totalContent}
          </div>
        </>
      )}
    </div>
  );
  */

  /*
  return (
    <div
      className={`row home-container ${
        showSidebar ? "show-sidebar" : "hide-sidebar"
      }`}
    >
      <button
        className="show-sidebar-button"
        onClick={() => setShowSidebar(!showSidebar)}
      >
        {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
      </button>
      {window.innerWidth <= 992 ? (
        showSidebar ? (
          <div className="col-12">
            <SidebarLeft />
          </div>
        ) : (
          <div className={`main-content col-12`}>{totalContent}</div>
        )
      ) : (
        <>
          <div className="col-2 sidebar-left">
            <SidebarLeft />
          </div>
          <div className={`main-content ${showSidebar ? "col-10" : "col-12"}`}>
            {totalContent}
          </div>
        </>
      )}
    </div>
  );
  */

  return (
    <div>
      <div className="row">
        <Toaster />

        <div>{totalContent}</div>
      </div>
    </div>
  );
};

export default Conference;
